export default function getOptionHelpers({
  agreementType,
  agreementVariant,
}: {
  agreementType: string[];
  agreementVariant: string[];
}) {
  const sortedTypes = [...agreementType].sort((currentType, nextType) =>
    currentType.localeCompare(nextType),
  );
  const sortedVariants = [...agreementVariant].sort(
    (currentVariant, nextVariant) => currentVariant.localeCompare(nextVariant),
  );

  const getSelectedTypes = (types: string[]) =>
    sortedTypes
      .filter((type) => types.includes(type))
      .map((type) => type)
      .join(', ');

  const getSelectedVariants = (variants: string[]) =>
    sortedVariants
      .filter((variant) => variants.includes(variant))
      .map((variant) => variant)
      .join(', ');

  return {
    getSelectedTypes,
    getSelectedVariants,
    sortedTypes,
    sortedVariants,
  };
}
